import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  navText: {
    textDecoration: "none",
    color: theme.palette.primary.contrastText,
    fontWeight: "bold",
    textTransform: "uppercase",
    padding: theme.spacing(1),
  },
  subnavText: {
    textDecoration: "none",
    color: theme.palette.primary.contrastText,
    textTransform: "uppercase",
  },
  list: {
    backgroundColor: theme.palette.primary.dark,
  },
}));

export default useStyles;
